import { react2angular } from 'react2angular';
import { ImageEditor } from './index';

export const ImageEditorModule = angular
  .module('app.components.ImageEditor', [])
  .component('imageEditor', react2angular(ImageEditor))
  .name;



// WEBPACK FOOTER //
// ./src/app/admin/components/ImageEditor/index.ng.js